(() => {
  const reduced = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  let footerObserver;
  function initFooter() {
    footerObserver?.disconnect();
    document.documentElement.classList.remove('joffz-footer-in-view');
    const footer = document.querySelector('.footer.joffz-footer--refined');
    if (footer && 'IntersectionObserver' in window) {
      footerObserver = new IntersectionObserver(([entry]) => {
        document.documentElement.classList.toggle('joffz-footer-in-view', entry.isIntersecting);
      });
      footerObserver.observe(footer);
    }
    document.querySelectorAll('.footer .accordion details').forEach(details => {
      if (details.dataset.footerAccordion) return;
      details.dataset.footerAccordion = 'true';
      const summary = details.querySelector('summary');
      let animation, closing = false;
      const setOpen = open => {
        const start = details.getBoundingClientRect().height;
        animation?.cancel();
        if (reduced()) { details.open = open; details.style.height = ''; return; }
        details.open = true;
        details.style.height = '';
        const end = open ? details.getBoundingClientRect().height : summary.getBoundingClientRect().height;
        closing = !open;
        details.style.height = start + 'px';
        animation = details.animate({ height: [start + 'px', end + 'px'] }, { duration: 280, easing: 'cubic-bezier(.2,.7,.2,1)' });
        animation.onfinish = () => { details.open = open; details.style.height = ''; animation = null; closing = false; };
      };
      summary.addEventListener('click', event => {
        event.preventDefault();
        setOpen(!details.open || closing);
      });
    });
    const member = () => {
      const club = document.querySelector('joffz-art-club');
      let completed = club?.dataset.completed === 'true' || club?.dataset.subscriber === 'true' || Boolean(document.querySelector('[data-footer-subscriber="true"]'));
      try { completed ||= localStorage.getItem('joffz-art-club-completed-v1') === '1'; } catch (_) {}
      completed ||= document.cookie.split(';').some(c => c.trim() === 'joffz-art-club-completed-v1=1');
      document.querySelectorAll('[data-footer-perks-cta]').forEach(el => el.hidden = completed);
      document.querySelectorAll('[data-footer-perks-member]').forEach(el => el.hidden = !completed);
    };
    member();
    if (!window.joffzFooterMemberEvents) {
      window.joffzFooterMemberEvents = true;
      ['joffz:art-club:completed','DOMContentLoaded'].forEach(event => document.addEventListener(event, member));
      ['storage','pageshow'].forEach(event => window.addEventListener(event, member));
      customElements.whenDefined('joffz-art-club').then(member);
    }
  }
  document.addEventListener('shopify:section:load', initFooter);
  initFooter();
})();
